import React from 'react';
import { motion } from 'framer-motion';
import { Heart, Quote, Star, MapPin, BadgeCheck } from 'lucide-react';
const testimonials = [{
  in: 'VA',
  n: 'Valentina A.',
  l: 'Tucumán',
  t: 'Nunca había trabajado como freelancer. En 10 días tenía mi perfil publicado, mis primeras 3 propuestas enviadas y un cliente que me pagó USD 60 por cargar datos en su tienda. El Tomo 2 me salvó.',
  tag: 'Tomo 2 · Servicio Elegido'
}, {
  in: 'NL',
  n: 'Nicolás L.',
  l: 'Rosario',
  t: 'Los scripts del Bono 1 son increíbles. Le escribí a 5 negocios locales de la misma forma que explica el bono y 2 me respondieron el mismo día. Uno cerró en la semana.',
  tag: 'Bono 1 · Mensajes para Clientes'
}, {
  in: 'DM',
  n: 'Daniela M.',
  l: 'Córdoba',
  t: 'El Tomo 6 me explicó exactamente cómo cobrar por Payoneer. Esa sola sección valió toda la compra. Recibí mis primeros USD en 48 horas después de configurar todo.',
  tag: 'Tomo 6 · Cobrar en Dólares'
}, {
  in: 'SC',
  n: 'Santiago C.',
  l: 'Buenos Aires',
  t: 'Con el Freelancer Pro implementé el sistema de Retainers y pasé de proyectos sueltos a tener 3 clientes que me pagan todos los meses. Es completamente diferente.',
  tag: 'Freelancer Pro · Sistema Retainers'
}];
export function MoreTestimonials() {
  return <section className="py-16 bg-graphite border-y border-petroleum relative overflow-hidden" data-id="element-449">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] bg-electric/5 blur-[120px] rounded-full pointer-events-none" data-id="element-450"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-451">
        {/* Framed Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative max-w-3xl mx-auto mb-12" data-id="element-452">
          <div className="absolute -inset-1 bg-electric rounded-3xl blur-xl opacity-25" data-id="element-453"></div>
          <div className="relative bg-gradient-to-br from-graphite via-petroleum to-graphite border-2 border-electric rounded-3xl p-8 md:p-10 text-center overflow-hidden shadow-2xl shadow-electric/20" data-id="element-454">
            <div className="absolute inset-0 opacity-[0.08] pointer-events-none" style={{
            backgroundImage: 'linear-gradient(rgba(245,185,66,0.6) 1px, transparent 1px), linear-gradient(90deg, rgba(245,185,66,0.6) 1px, transparent 1px)',
            backgroundSize: '24px 24px'
          }} data-id="element-455"></div>
            <div className="absolute top-0 left-0 w-14 h-14 border-t-4 border-l-4 border-electric rounded-tl-3xl pointer-events-none" data-id="element-456"></div>
            <div className="absolute top-0 right-0 w-14 h-14 border-t-4 border-r-4 border-electric rounded-tr-3xl pointer-events-none" data-id="element-457"></div>
            <div className="absolute bottom-0 left-0 w-14 h-14 border-b-4 border-l-4 border-electric rounded-bl-3xl pointer-events-none" data-id="element-458"></div>
            <div className="absolute bottom-0 right-0 w-14 h-14 border-b-4 border-r-4 border-electric rounded-br-3xl pointer-events-none" data-id="element-459"></div>

            <div className="relative z-10" data-id="element-460">
              <div className="inline-flex items-center gap-2 bg-electric text-graphite px-4 py-1.5 rounded-full text-xs font-extrabold uppercase tracking-wider mb-5 shadow-lg shadow-electric/40" data-id="element-461">
                <Heart className="w-3.5 h-3.5 fill-graphite" data-id="element-462" />
                Historias reales
              </div>
              <h2 className="text-2xl md:text-4xl font-extrabold leading-tight" data-id="element-463">
                <span className="text-white" data-id="element-464">Más personas que </span>
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-electric via-gold to-electric drop-shadow-[0_0_12px_rgba(245,185,66,0.4)]" data-id="element-465">
                  ya lo tienen
                </span>
              </h2>
              <div className="mt-4 mx-auto h-px w-32 bg-gradient-to-r from-transparent via-electric to-transparent opacity-70" data-id="element-466"></div>

              {/* Aggregate trust row */}
              <div className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs text-textsecondary" data-id="element-467">
                <div className="flex items-center gap-1.5" data-id="element-468">
                  <div className="flex" data-id="element-469">
                    {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 text-gold fill-gold" data-id="element-470" />)}
                  </div>
                  <span className="text-white font-bold" data-id="element-471">4.9/5</span>
                  <span data-id="element-472">· +500 compradores</span>
                </div>
                <span className="hidden md:inline w-1 h-1 rounded-full bg-textsecondary/40" data-id="element-473"></span>
                <div className="flex items-center gap-1.5" data-id="element-474">
                  <BadgeCheck className="w-3.5 h-3.5 text-electric" data-id="element-475" />
                  <span data-id="element-476">Compras verificadas</span>
                </div>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Testimonial Cards */}
        <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-477">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} className="group relative bg-gradient-to-br from-petroleum to-graphite border border-white/10 rounded-2xl p-6 hover:border-electric/40 hover:shadow-[0_0_30px_rgba(245,185,66,0.15)] transition-all duration-300" data-id="element-478">
              {/* Decorative quote mark */}
              <Quote className="absolute top-5 right-5 w-8 h-8 text-electric/15 group-hover:text-electric/30 transition-colors" strokeWidth={2.5} data-id="element-479" />

              {/* Header: avatar + name + location */}
              <div className="flex items-center gap-3 mb-4" data-id="element-480">
                <div className="relative" data-id="element-481">
                  <div className="w-11 h-11 rounded-full bg-gradient-to-br from-electric to-golddark text-graphite flex items-center justify-center font-extrabold text-sm shadow-lg shadow-electric/30" data-id="element-482">
                    {t.in}
                  </div>
                  <div className="absolute -bottom-0.5 -right-0.5 w-4 h-4 rounded-full bg-graphite flex items-center justify-center" data-id="element-483">
                    <BadgeCheck className="w-4 h-4 text-electric" strokeWidth={2.5} data-id="element-484" />
                  </div>
                </div>
                <div className="flex-1" data-id="element-485">
                  <div className="text-sm font-bold text-white flex items-center gap-1.5" data-id="element-486">
                    {t.n}
                  </div>
                  <div className="text-xs text-textsecondary flex items-center gap-1" data-id="element-487">
                    <MapPin className="w-3 h-3" data-id="element-488" />
                    {t.l}
                  </div>
                </div>
                {/* Rating */}
                <div className="flex gap-0.5" data-id="element-489">
                  {[...Array(5)].map((_, idx) => <Star key={idx} className="w-3 h-3 text-gold fill-gold" data-id="element-490" />)}
                </div>
              </div>

              {/* Quote */}
              <p className="text-sm text-textsecondary leading-relaxed mb-4 relative z-10" data-id="element-491">
                "{t.t}"
              </p>

              {/* Tag */}
              <div className="pt-3 border-t border-white/5" data-id="element-492">
                <span className="inline-flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-wider text-electric bg-electric/10 px-2.5 py-1 rounded-full" data-id="element-493">
                  <span className="w-1 h-1 rounded-full bg-electric" data-id="element-494"></span>
                  {t.tag}
                </span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}